<template lang="pug">
  v-app
    v-app-bar(height=100 app color="#0b0c0e")
      v-btn.logo.hidden-md-and-down(:to="{ name: 'Home' }" exact icon height=70 width=70)
        v-avatar(size=70 v-if="$route.name == 'Home'").primary
          v-img(src="./assets/logo.png")
        v-avatar(v-else size=70).primary
          v-icon(x-large).black--text.home mdi-home
      v-spacer
      v-row(align="center").flex-nowrap
        v-col.hidden-lg-and-up.pa-0
          v-btn(:to="{ name: 'Home' }" exact icon :height="logoSize" :width="logoSize")
            v-avatar(:size="logoSize" v-if="$route.name == 'Home'").primary
              v-img(src="./assets/logo.png")
            v-avatar(v-else :size="logoSize").primary
              v-icon(:large="$vuetify.breakpoint.smAndUp").black--text.home mdi-home
        v-col.pa-0(v-for="m in menu" :key="m.route")
          v-btn(:to="{ name: m.route }" exact outlined color="primary" :x-small="$vuetify.breakpoint.xsOnly"
          :small="$vuetify.breakpoint.smAndUp" :x-large="$vuetify.breakpoint.lgAndUp") {{ m.name }}
      v-spacer
    transition(name="fade" mode="out-in")
      router-view(style="animation-duration: 0.2s")
</template>

<style lang="stylus">
.v-app-bar
  a:not(.v-btn--active)
    color white !important
    border 0px

.logo
  margin-left 100px !important

  .home
    font-size 48px !important
</style>

<script>
export default {
  name: 'App',

  data: () => ({
    menu: [
      { route: 'Photo', name: 'Фото' },
      { route: 'Video', name: 'Видео' },
      { route: 'Tour', name: 'Экскурсии' },
      { route: 'Recomendation', name: 'Рекомендации' },
      { route: 'About', name: 'Обо мне' }
    ]
  }),
  computed: {
    logoSize() {
      return this.$vuetify.breakpoint.xs
        ? 25
        : this.$vuetify.breakpoint.sm
        ? 40
        : this.$vuetify.breakpoint.md
        ? 55
        : 70
    }
  }
}
</script>
